import { allTankMetricNames } from '@shared_types/metrics/tank_metrics'
import type { Metric } from '@shared_types/vessel_data'
import { initializeMetrics } from '@shared_utils/metric_utils'

import { LOAD_TANKS, UPDATE_TANKS } from '../actions'

const initialState = initializeMetrics(allTankMetricNames)

interface TanksPayload {
  tankBallastWater1: Metric
  tankBallastWater2: Metric
  tankBallastWater3: Metric
  tankBallastWater4: Metric
  tankBallastWater5: Metric
  tankBallastWater6: Metric
  tankBallastWater7: Metric
  tankBallastWater8: Metric
  tankBallastWater9: Metric
  tankBallastWater10: Metric
  tankFreshWater1: Metric
  tankFreshWater2: Metric
  tankFreshWater3: Metric
  tankFreshWater4: Metric
  tankFreshWater5: Metric
  tankFreshWater6: Metric
  tankFreshWater7: Metric
  tankFreshWater8: Metric
  tankFreshWater9: Metric
  tankFreshWater10: Metric
  tankPoolWater1: Metric
  tankPoolWater2: Metric
  tankPoolWater3: Metric
  tankPoolWater4: Metric
  tankPoolWater5: Metric
  tankPoolWater6: Metric
  tankPoolWater7: Metric
  tankPoolWater8: Metric
  tankPoolWater9: Metric
  tankPoolWater10: Metric
  tankFuel1: Metric
  tankFuel2: Metric
  tankFuel3: Metric
  tankFuel4: Metric
  tankFuel5: Metric
  tankFuel6: Metric
  tankFuel7: Metric
  tankFuel8: Metric
  tankFuel9: Metric
  tankFuel10: Metric
}

export default function init (previousState = initialState, { type, payload }: { type: string; payload: TanksPayload }) {
  if (type === LOAD_TANKS || type === UPDATE_TANKS) {
    return Object.assign({}, previousState, payload)
  } else {
    return previousState
  }
}
